import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { generalOfferEndpointsToInvalidate } from '../offer/offerEndpoints';
import { DerivedScrapQuantityDTORuntype, SolutionDTORuntype } from '../solution/solutionBackendTypes';
import {
    BulkSourcingLineItemUpdateRuntype,
    SourcingLineItemCalculationRuntype,
    SourcingLineItemSyncRequestRuntype,
    SourcingLineItemUpdateRequestRuntype,
} from './sourcingLineItemBackendTypes';

export const sourcingLineItemEndpoints = {
    'GET /sourcing-line-item/:id': endpoint({
        description:
            'Returns the legacy sourcing line item calculation. Only used to read the derived scrap quantity (incl. the evaluated scrap formula), which the flattened calculation endpoints do not expose.',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.object({
                sourcing_line_item_summary: z.object({
                    scrap_quantity: DerivedScrapQuantityDTORuntype.nullable(),
                }),
            }),
        }),
    }),

    'GET /sourcing/calculation/line-items/:id': endpoint({
        description: 'Returns a single sourcing line item calculation by id',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ data: SourcingLineItemCalculationRuntype }),
    }),

    'GET /sourcing-line-item/:id/solutions': endpoint({
        description: 'Returns an array of solutions for the sourcing line item',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(SolutionDTORuntype),
    }),

    'PATCH /sourcing-line-item/:id': endpoint({
        description: 'Updates a sourcing line item',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: SourcingLineItemUpdateRequestRuntype,
        responseBody: z.string(),
        invalidates: [
            ...generalOfferEndpointsToInvalidate,
            'GET /sourcing/progress/:rfqId',
            'POST /sourcing/calculation/read-selection',
            'POST /sourcing/calculation/summary',
            'GET /sourcing/calculation/line-items/:id',
            'GET /sourcing-line-item/:id',
        ],
    }),

    'PATCH /sourcing-line-item': endpoint({
        description: 'Updates multiple sourcing line items',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: BulkSourcingLineItemUpdateRuntype,
        responseBody: z.string(),
        invalidates: [
            ...generalOfferEndpointsToInvalidate,
            'GET /sourcing/progress/:rfqId',
            'POST /sourcing/calculation/read-selection',
            'POST /sourcing/calculation/summary',
            'GET /sourcing/calculation/line-items/:id',
            'GET /sourcing-line-item/:id',
        ],
    }),
    'POST /sourcing-line-item/sync': endpoint({
        description: 'Syncs sourcing line items',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: SourcingLineItemSyncRequestRuntype,
        responseBody: z.string(),
        invalidates: [
            ...generalOfferEndpointsToInvalidate,
            'GET /sourcing/progress/:rfqId',
            'POST /sourcing/calculation/read-selection',
            'POST /sourcing/calculation/summary',
            'GET /sourcing/calculation/line-items/:id',
            'GET /sourcing-line-item/:id',
        ],
    }),
};
